import axiosInstance from "../services/axiosInstance";
import { clearAuthTokens, getAccessToken } from "../utils/authStorage";


export const updateCardStatus = async (uniqueCode, isPaid) => {
    const response = await axiosInstance.patch(`/api/admin/cards/${uniqueCode}/status`, null, {
        params: { isPaid },
    });
    return response.data;
};

export const getCardByUniqueCode = async (uniqueCode) => {
    const response = await axiosInstance.get(`/api/admin/cards/${uniqueCode}`);
    return response.data;
};

export const generateCardLink = async (uniqueCode) => {
    const response = await axiosInstance.post(`/api/admin/cards/${uniqueCode}/generate-link`);
    return response.data;
};

export const isAuthenticated = () => {
    return !!getAccessToken();
};

